import { PollingStatus, StatusProvider } from '@/tax/models';

export class RagFileStatus {
    id = 0;
    ragfile = 0;
    creationDate = new Date();
    endDate?: Date;
    status = PollingStatus.Init;
    statusMessage?: string;
    statusMessageProvider?: StatusProvider;

    deserialize(data: any) {
        this.id = data.id ?? 0;
        this.ragfile = data.ragFile ?? 0;
        this.creationDate = data.created_at ? new Date(data.created_at) : new Date();
        this.endDate = data.end_date ? new Date(data.end_date) : undefined;
        this.status = data.status ?? PollingStatus.Init;
        this.statusMessage = data.status_message ?? undefined;
        this.statusMessageProvider = data.status_message_provider ?? undefined;
        return this;
    }
}
